import axios from "axios";
import { authHeader } from "./utils";
import { GET_MESSAGE, LIST_MESSAGE } from "./types";

export const getMessage = (id) => async (dispatch) => {
  const res = await axios.get(`/api/messages/${id}`, {
    headers: authHeader(),
  });
  console.log("res", res.data);
  dispatch({ type: GET_MESSAGE, payload: res.data });
};

export const fetchMessages = (page, limit) => async (dispatch) => {
  const res = await axios.get("/api/messages", {
    headers: authHeader(),
    params: { page, limit },
  });
  console.log("res", res.data);
  dispatch({ type: LIST_MESSAGE, payload: res.data });
};

export const submitMessage =
  ({ message }, navigate) =>
  async (dispatch) => {
    const res = await axios.post("/api/messages", message, {
      headers: authHeader(),
    });
    navigate("/messages");
  };

export const updateMessage =
  ({ message, id }, navigate) =>
  async (dispatch) => {
    const res = await axios.put(`/api/messages/${id}`, message, {
      headers: authHeader(),
    });
    navigate("/messages");
  };

export const deleteMessage =
  ({ id }, navigate) =>
  async (dispatch) => {
    try {
      const res = await axios.delete(`/api/messages/${id}`, {
        headers: authHeader(),
      });
      navigate("/messages");
    } catch (error) {
      console.log(error);
    }
  };
